import { L3OnboardingFlowGroup } from '@shared/graphql'

/**
 * List of groups that should be fully editable if
 * RFI is active.
 */
export const EditableGroups = [
  `${L3OnboardingFlowGroup.beneficialOwnerPersons}`,
  `${L3OnboardingFlowGroup.beneficialOwnerEntity}`,
  `${L3OnboardingFlowGroup.individualWithSignificantControlPersons}`,
  `${L3OnboardingFlowGroup.trustRelatedPersons}`,
  `${L3OnboardingFlowGroup.trustRelatedEntity}`,
  `${L3OnboardingFlowGroup.complianceOfficer}`,
  `${L3OnboardingFlowGroup.topFiveInvestorEntity}`,
  `${L3OnboardingFlowGroup.topFiveInvestorPersons}`,
  `${L3OnboardingFlowGroup.investorPersons}`,
  `${L3OnboardingFlowGroup.significantDonorsAbove25PctEntity}`,
  `${L3OnboardingFlowGroup.significantDonorsAbove25PctPersons}`,
  `${L3OnboardingFlowGroup.tokenHolderPersons}`,
  `${L3OnboardingFlowGroup.investorDueDiligencePerformerEntity}`,
  `${L3OnboardingFlowGroup.donorPersons}`,
  `${L3OnboardingFlowGroup.donorEntity}`,
  `${L3OnboardingFlowGroup.assetManagerEntity}`,
]

/**
 * List of groups that only contain question-bank questions
 * Data will never be returned by /groups/:groupId/data API.
 */
export const QuestionBankGroups = [
  `${L3OnboardingFlowGroup.topFiveInvestorsDetails}`,
  `${L3OnboardingFlowGroup.assetManagerDetails}`,
]

/**
 * List of details groups for every page
 * These groups are always invoked during a save.
 */
export const DetailsGroups = [
  // Business details
  L3OnboardingFlowGroup.businessRegistrationDetails,
  L3OnboardingFlowGroup.physicalBusinessAddress,
  L3OnboardingFlowGroup.registeredOfficeAddress,
  L3OnboardingFlowGroup.intendedUseOfAccount,
  L3OnboardingFlowGroup.basicBusinessInfo,
  L3OnboardingFlowGroup.entityOperations,

  // Related parties
  L3OnboardingFlowGroup.beneficialOwnersDetails,
  L3OnboardingFlowGroup.tokenHoldersDetails,
  L3OnboardingFlowGroup.individualsWithSignificantControlDetails,
  L3OnboardingFlowGroup.trustRelatedPartiesDetails,
  L3OnboardingFlowGroup.topFiveInvestorsDetails,
  L3OnboardingFlowGroup.investorsDetails,
  L3OnboardingFlowGroup.donorsDetails,
  L3OnboardingFlowGroup.significantDonorsAbove25PctDetails,
  L3OnboardingFlowGroup.assetManagerDetails,
  L3OnboardingFlowGroup.partyPerformingInvestorDueDiligenceDetails,

  // Additional information
  L3OnboardingFlowGroup.licensingAndRegistration,
  L3OnboardingFlowGroup.financialCrimesComplianceDetails,
  L3OnboardingFlowGroup.authorizedRepresentative,
  L3OnboardingFlowGroup.additionalUsersPersons,
  L3OnboardingFlowGroup.additionalUsersPersonsKyc,

  // Tax info
  L3OnboardingFlowGroup.taxInfoEeaVat,
  L3OnboardingFlowGroup.fatcaInformation,
  L3OnboardingFlowGroup.selfCertificationCrs,
]
